module.exports = __webpack_public_path__ + "img/buscar.90a9c10b.svg";